import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue";
import AccountLoged from "@/shared/mixins/AccountLoged";

// import UsuarioController from "@/shared/controllers/usuario/usuarioController";
export default {
  name:'GerenciamentoUsuarios',
  components: { 
    gCard,
    gForm,
    'g-button': gButton
  }, 
  mixins:[AccountLoged],

  props: { },

  mounted () { 
    if(!this.hasClaim('Gerenciamento-Usuário')) {
      this.$router.push('/sem-acesso')
    }
   },

  updated () { },

  data () {
    return { 
      nomeUsuario: null,
      login: null,
      UsuariosArray: [],
      Colunas : [
        {field: 'nomeUsuario', header: 'Usuário'},
        {field: 'login', header: 'Login'},
        {field: 'email', header: 'Email'},
        {field: 'bloqueadoSimNao', header: 'Bloqueado?'},
        {field: 'inativoSimNao', header: 'Inativo?'},
      ],
      mensagemvazio: true,
      popupExcluir: false,
      popupGrupoExistente: false
    }
  },

  methods: {
    buscarUsuarios(){
      (this.mensagemvazio = false), this.$isLoading(true)
      let dataParaOBack = {
          Login: this.login,
          NomeUsuario: this.nomeUsuario,
        }
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + `Usuario/GetUsuariosGerenciamentoByFiltro`,
          data: dataParaOBack
        })
          .then((res) => {
            this.UsuariosArray = res.data.data
            this.$isLoading(false)
          })
          .catch(() => {
            this.$isLoading(false)
          });
    },

    limparFiltro(){
      this.nomeUsuario = null
      this.login = null
    },

    excluir(usuarioSelecionado){
      this.popupExcluir = true
      this.UsuarioId = usuarioSelecionado.id
     
    },

    confirmacaoExcluir(){

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Usuario/VerificarGrupoUsuario/${this.UsuarioId}`,
      })
        .then((res) => {
          if(res.data.data == null)
          {
            this.popupExcluir = false
            this.excluirUsuario()
          }
          else{
            this.popupExcluir = false
            this.popupGrupoExistente = true
            
          }

      
        })
        .catch(() => {
          this.$isLoading(false)
        });     
    },

    excluirUsuario(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Usuario/ExcluirUsuario/${this.UsuarioId}`,
      })
        .then(() => {
          this.popupExcluir = false
          this.$isLoading(false)

          this.buscarUsuarios()

        })
        .catch(() => {
          this.$isLoading(false)
        });
    },
    cadastrarUsuario() {
      this.$router.push('/cadastro-usuario')
    },
    detalhesUsuario(data){
      this.$store.state.usuarioId = data.id

      this.$store.commit('salvando');
      this.$router.push(`/cadastro-usuario/${data.id}?edicao=true`)
    },
 
   },

  computed: { }, 

};